import React, { useMemo } from 'react';
import Select from 'react-select';
import { Rating } from 'react-simple-star-rating';
import InclusionHeaderRow from '../common/InclusionHeaderRow';

const HotelInclusion = ({
    disabled,
    isHotelIncluded,
    hotelList,
    hotelnameid,
    handlehotelnamechange,
    hoteldisable,
    hotelopen,
    handleHotel,
    hotelname,
    hotelrating,
    roomtypelist,
    hotelroomtypeid,
    handleRoomTypeChange,
    roomMealList,
    mealTypeId,
    handleMealType,
    formvalue,
    onChange
}) => {
    const selectedRoomType = useMemo(
        () => roomtypelist?.find(item => item.value === hotelroomtypeid) || null,
        [roomtypelist, hotelroomtypeid]
    );

    const selectedMealType = useMemo(
        () => roomMealList?.find(item => item.value === mealTypeId) || null,
        [roomMealList, mealTypeId]
    );

    return (
        <>
            <InclusionHeaderRow
                label={<>Add Hotels <br /> Or Similar Hotels</>}
                required={isHotelIncluded}
                datalist={hotelList}
                fieldid={hotelnameid}
                onSelectionChange={handlehotelnamechange}
                isDisabled={disabled || !isHotelIncluded}
                isActiveDisable={hoteldisable}
                isSearchable
                isOpen={hotelopen}
                onToggle={handleHotel}
                buttonDisabled={!isHotelIncluded}
            />

            {hotelopen && (
                <div className="col-lg-12 col-sm-12 mt-3 mb-2 py-2 form_border ms-2">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 mb-1">
                            <label className="col-form-label">
                                {hotelname}
                                <Rating
                                    readonly
                                    size={20}
                                    allowFraction
                                    className="ms-2"
                                    initialValue={hotelrating}
                                />
                            </label>
                        </div>

                        <div className="col-lg-6 col-sm-6">
                            <div className="row">
                                <div className="col-lg-4 col-md-12 mb-1">
                                    <label className="col-form-label required">Select Room Type</label>
                                </div>
                                <div className="col-lg-8 mb-1 col-md-12">
                                    <Select
                                        className="dropdown select_dropdown"
                                        options={roomtypelist}
                                        value={selectedRoomType}
                                        onChange={handleRoomTypeChange}
                                        isDisabled={disabled}
                                        isSearchable
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6 col-sm-6">
                            <div className="row">
                                <div className="col-lg-4 col-md-12 mb-1">
                                    <label className="col-form-label">No Of Pax</label>
                                </div>
                                <div className="col-lg-8 mb-1 col-md-12">
                                    <Select
                                        className="dropdown select_dropdown"
                                        options={[{ label: 2, value: 2 }]}
                                        value={{ label: 2, value: 2 }}
                                        isDisabled={disabled}
                                        isSearchable
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6 col-sm-6">
                            <div className="row">
                                <div className="col-lg-4 col-md-12 mb-1">
                                    <label className="col-form-label required">Meal Type</label>
                                </div>
                                <div className="col-lg-8 mb-1 col-md-12">
                                    <Select
                                        className="dropdown select_dropdown"
                                        options={roomMealList}
                                        value={selectedMealType}
                                        onChange={handleMealType}
                                        isDisabled={disabled}
                                        isSearchable
                                    />
                                </div>
                            </div>
                        </div>

                        {formvalue?.IsPriceType === true && (
                            <div className="col-lg-6 col-sm-6">
                                <div className="row">
                                    <div className="col-lg-4 col-md-12 mb-1">
                                        <label className="col-form-label">Price</label>
                                    </div>
                                    <div className="col-lg-8 mb-1 col-md-12">
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="RoomPriceD"
                                            disabled
                                            value={formvalue?.HotelPrice || ''}
                                            onChange={onChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export default React.memo(HotelInclusion);

